var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxButtonGroup',{attrs:{"items":_vm.items,"key-expr":"name","styling-mode":"outlined"},on:{"item-click":_vm.itemClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }